import { Languages } from 'next/dist/lib/metadata/types/alternative-urls-types'

export const PM_NAMESPACE = 'productivity-methods'
export const PM_PATH = '/productivity-methods'

const QUIZ_URLS = {
    en: 'https://doist.typeform.com/to/nqf2kj',
    nl: 'https://doist.typeform.com/to/Uryc4TV5',
    fr: 'https://doist.typeform.com/to/T3Q3yoGy',
    de: 'https://doist.typeform.com/to/ub79XfQM',
    es: 'https://doist.typeform.com/to/wuBY4lFr',
    'pt-BR': 'https://doist.typeform.com/to/Jdtf4Q63',
} as const

type QuizLanguage = keyof typeof QUIZ_URLS
type QuizUrl = (typeof QUIZ_URLS)[QuizLanguage]
const QUIZ_LANGUAGES = Object.keys(QUIZ_URLS) as QuizLanguage[]

export const SUPPORTED_CONTENTFUL_LANGUAGES = [
    'en',
    'fr',
    'ja',
    'ru',
    'de',
    'nl',
    'es',
    'pt-BR',
] as const
export type SupportedLanguage = (typeof SUPPORTED_CONTENTFUL_LANGUAGES)[number]

function isValidContentLocale(lang: string): lang is SupportedLanguage {
    return SUPPORTED_CONTENTFUL_LANGUAGES.includes(lang as SupportedLanguage)
}

export function getSupportedLocale(lang: string): SupportedLanguage {
    const supportedLocale = isValidContentLocale(lang) ? lang : 'en'
    return supportedLocale
}

function isValidQuizLanguage(lang: string): lang is QuizLanguage {
    return QUIZ_LANGUAGES.includes(lang as QuizLanguage)
}

export function getQuizURL(lang: string): QuizUrl {
    const quizLang: QuizLanguage = isValidQuizLanguage(lang) ? lang : 'en'
    return QUIZ_URLS[quizLang]
}

export function filterLanguages(languages: Languages<string>) {
    const filteredLanguages = Object.fromEntries(
        Object.entries(languages).filter((key) => {
            return isValidContentLocale(key[0])
        }),
    )

    return filteredLanguages
}
